<template>
  <div
    class="frorm-group"
    :class="{'is-block': block}"
  >
    <label
      v-if="$slots.label"
      :for="selectId"
    >
      <slot name="label" />
    </label>
    <small
      v-if="$slots.info"
      class="form-text"
    >
      <slot name="info" />
    </small>
    <select
      :id="selectId"
      class="form-control custom-select"
      :class="{
        'custom-select-lg': size === 'lg',
        'custom-select-sm': size === 'sm',
        'is-invalid': $slots.error
      }"
      :multiple="multiple"
      :disabled="disabled"
      @change="updateValue($event.target.value)"
    >
      <option
        v-if="placeholder"
        value=""
        :selected="!isSelected"
        disabled
      >
        {{ placeholder }}
      </option>
      <template v-for="(item, index) in items">
        <option
          :key="index"
          :value="item.value"
          :selected="item.selected"
        >
          {{ item.text }}
        </option>
      </template>
    </select>
    <small
      v-if="$slots.error"
      class="form-text invalid-feedback"
    >
      <slot name="error" />
    </small>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * @parm: ARRAY<Object>
     * {
     *  text: <String>: show list data
     *  value: <Sting | Number | Boolean>: selected data
     *  selected: true: default selected
     * }
     */
    items: {
      type: Array,
      required: true,
      validate: (d) => {
        if (!d.length) return false
        return d.every((data) => {
          return ('text' in data) && ('value' in data)
        })
      }
    },
    selectId: {
      type: String,
      default: 'select'
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '',
      validate: (d) => {
        if (!d) return true
        return ['lg', 'sm'].include(d)
      }
    },
    block: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      derault: false
    }
  },
  computed: {
    isSelected () {
      if (!this.items) return false
      return this.items.some( (i) => i.selected )
    }
  },
  methods: {
    updateValue(e) {
      this.$emit('selectedData', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.is-block {
  width: 100%;
}
.form-control {
  color: #3a474f;
  background-color: #f9f9fa;
  cursor: pointer;
}
</style>
